


















import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocPercorsoFormativo } from "../../_models/docPercorsoFormativo";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ProgettoOrientamentoTirEstivoReview extends Vue {
  @Prop() docInfo!: DocPercorsoFormativo;
  private ruoloUtente: number[];

  private elements: DocPercorsoFormativo;
  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.elements = {
      idPercorsoFormativo: this.docInfo.idPercorsoFormativo,
      idRichiesta: this.docInfo.idRichiesta,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      comuneIstituto: this.docInfo.comuneIstituto,
      tutorFormativo: this.docInfo.tutorFormativo,
      emailTutorFormativo: this.docInfo.emailTutorFormativo,
      tutorAziendale: this.docInfo.tutorAziendale,
      emailTutorAziendale: this.docInfo.emailTutorAziendale,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      capTirocinio: this.docInfo.capTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      tirocinante: this.docInfo.tirocinante,
      dataNascitaTirocinante: this.docInfo.dataNascitaTirocinante,
      luogoNascitaTirocinante: this.docInfo.luogoNascitaTirocinante,
      indirizzoTirocinante: this.docInfo.indirizzoTirocinante,
      comuneTirocinante: this.docInfo.comuneTirocinante,
      provinciaTirocinante: this.docInfo.provinciaTirocinante,
      telefonoTirocinante: this.docInfo.telefonoTirocinante,
      emailTirocinante: this.docInfo.emailTirocinante,
      codiceFiscaleTirocinante: this.docInfo.codiceFiscaleTirocinante,
      classeTirocinante: this.docInfo.classeTirocinante,
      durataTirocinio: this.docInfo.durataTirocinio,
      dataInizioPeriodo: this.docInfo.dataInizioPeriodo,
      dataFinePeriodo: this.docInfo.dataFinePeriodo,
      orarioInizioMattino: this.docInfo.orarioInizioMattino,
      orarioFineMattino: this.docInfo.orarioFineMattino,
      orarioInizioPomeriggio: this.docInfo.orarioInizioPomeriggio,
      orarioFinePomeriggio: this.docInfo.orarioFinePomeriggio,
      usoFuoriSede: this.docInfo.usoFuoriSede,
      attivitaTirocinio: this.docInfo.attivitaTirocinio,
      posizioneInail: this.docInfo.posizioneInail,
      numeroPolizzaAssicurativa: this.docInfo.numeroPolizzaAssicurativa,
      assicurazione: this.docInfo.assicurazione,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDocumento: this.docInfo.idStatoDocumento,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaTirocinante: this.docInfo.firmaTirocinante,
      firmaTutore: this.docInfo.firmaTutore,
      idTipoAttivita: this.docInfo.idTipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate,
      tutore: this.docInfo.tutore,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      pivaAzienda: this.docInfo.pivaAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      firmaIstituto: this.docInfo.firmaIstituto,
      firmaAziendaDue: this.docInfo.firmaAziendaDue,
      firmaTutorArticolazione: this.docInfo.firmaTutorArticolazione,
      tutorArticolazione: this.docInfo.tutorArticolazione,
      emailTutorArticolazione: this.docInfo.emailTutorArticolazione,
      mansione: this.docInfo.mansione,
      reparto: this.docInfo.reparto,
      attrezzatura: this.docInfo.attrezzatura,
      dpi: this.docInfo.dpi
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }
    if (this.elements.firmaAziendaDue === null) {
      this.elements.firmaAziendaDue = images.noFirma;
    }
    if (this.elements.firmaTutore === null) {
      this.elements.firmaTutore = images.noFirma;
    }
    if (this.elements.firmaTirocinante === null) {
      this.elements.firmaTirocinante = images.noFirma;
    }
    if (this.elements.firmaTutorArticolazione === null) {
      this.elements.firmaTutorArticolazione = images.noFirma;
    }
    var finalDocStr: string = this.completeDoc();

    var json = JSON.parse(finalDocStr);
    const pdfDocGenerator = pdfMake.createPdf(json);

    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_codAteco_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_codIstat_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinio_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinio_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinio_%%/g,
      this.elements.numeroProtocollo
    );
    completeDoc = completeDoc.replace(
      /%%_tutorFormativo_%%/g,
      this.elements.tutorFormativo
    );
    completeDoc = completeDoc.replace(
      /%%_emailTutorFormativo_%%/g,
      this.elements.emailTutorFormativo
    );
    completeDoc = completeDoc.replace(
      /%%_tutorAziendale_%%/g,
      this.elements.tutorAziendale
    );
    completeDoc = completeDoc.replace(
      /%%_emailTutorAziendale_%%/g,
      this.elements.emailTutorAziendale
    );
    completeDoc = completeDoc.replace(
      /%%_tirocinante_%%/g,
      this.elements.tirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaTirocinante_%%/g,
      this.elements.luogoNascitaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaTirocinante_%%/g,
      this.elements.dataNascitaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinante_%%/g,
      this.elements.indirizzoTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinante_%%/g,
      this.elements.comuneTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinante_%%/g,
      this.elements.provinciaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoTirocinante_%%/g,
      this.elements.telefonoTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleTirocinante_%%/g,
      this.elements.codiceFiscaleTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_classeTirocinante_%%/g,
      this.elements.classeTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_dataInizioPeriodo_%%/g,
      this.elements.dataInizioPeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_dataFinePeriodo_%%/g,
      this.elements.dataFinePeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_orarioInizioMattino_%%/g,
      this.elements.orarioInizioMattino
    );
    completeDoc = completeDoc.replace(
      /%%_orarioFineMattino_%%/g,
      this.elements.orarioFineMattino
    );
    completeDoc = completeDoc.replace(
      /%%_orarioInizioPomeriggio_%%/g,
      this.elements.orarioInizioPomeriggio
    );
    completeDoc = completeDoc.replace(
      /%%_orarioFinePomeriggio_%%/g,
      this.elements.orarioFinePomeriggio
    );
    completeDoc = completeDoc.replace(
      /%%_usoFuoriSede_%%/g,
      this.elements.usoFuoriSede
    );
    completeDoc = completeDoc.replace(
      /%%_attivitaTirocinio_%%/g,
      this.elements.attivitaTirocinio
    );
    completeDoc = completeDoc.replace(/%%_tutore_%%/g, this.elements.tutore);
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pivaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTirocinante_%%/g,
      this.elements.firmaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAziendaDue_%%/g,
      this.elements.firmaAziendaDue
    );
    // completeDoc = completeDoc.replace(
    //   /%%_firmaTirocinanteDue_%%/g,
    //   this.elements.firmaTirocinante
    // );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTutorArticolazione_%%/g,
      this.elements.firmaTutorArticolazione
    );
    completeDoc = completeDoc.replace(
      /%%_tutorArticolazione_%%/g,
      this.elements.tutorArticolazione
    );
    completeDoc = completeDoc.replace(
      /%%_tutorArticolazione_%%/g,
      this.elements.tutorArticolazione
    );
    completeDoc = completeDoc.replace(
      /%%_emailTutorArticolazione_%%/g,
      this.elements.emailTutorArticolazione
    );
    completeDoc = completeDoc.replace(
      /%%_mansione_%%/g,
      this.elements.mansione
    );
    completeDoc = completeDoc.replace(
      /%%_reparto_%%/g,
      this.elements.reparto
    );
    completeDoc = completeDoc.replace(
      /%%_attrezzatura_%%/g,
      this.elements.attrezzatura
    );
    completeDoc = completeDoc.replace(
      /%%_dpi_%%/g,
      this.elements.dpi
    );
    return completeDoc;
  }

  confirm() {
    var payload = {
      idPercorsoFormativo: this.elements.idPercorsoFormativo
    };
    if (
      this.elements.firmaAzienda !== null &&
      this.elements.firmaTirocinante !== null &&
      this.elements.firmaTutore !== null
    ) {
      user
        .dispatchConfirmPercorsoFormativo(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit(
            "successfullOperation",
            "Progetto Formativo accettato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda e/o Firma Tirocinante mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idPercorsoFormativo: this.elements.idPercorsoFormativo
    };
    if (
      this.elements.firmaAzienda !== null &&
      this.elements.firmaTirocinante !== null &&
      this.elements.firmaTutore !== null
    ) {
      user
        .dispatchRefusePercorsoFormativo(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit(
            "successfullOperation",
            "Progetto Formativo rifiutato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda e/o Firma Tirocinante mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  // created() {
  //   var userInfo = user.readUserInfo(this["$store"]);
  //   if (userInfo === null) {
  //     userInfo = user.readStudentInfo(this["$store"]);
  //   }
  //   this.ruoloUtente = userInfo.ruoloUtente;
  //   this.createDoc();
  // }

  created() {
    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        // if (this.docInfo.tipoAttivita === "tirocinioReIns") {
        //   this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        // } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
        //   this.tipoAttivita = "tirocinio formativo e di orientamento";
        // }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        // console.log(error)
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });

    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();
  }
}
